// Dev deploy cache-buster: forces a fresh medonc-dashboard build on development.
import { initAll } from "@amplitude/unified";
import { ToastContainer } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { PayerNameContextFromSingleOrderLayoutProvider } from "./context/payerNameContextFromSingleOrderLayout";
import { RemoteConfigProvider } from "./context/remoteConfigContext";
import { TablesContextProvider } from "./context/tablesContextProvider";
import { UserThemeContextProvider } from "./context/userThemeContext";
import "./index.css";
import store from "./redux/store/store";
import { getEnv, isProduction as isProductionEnv } from "./utils/runtimeEnv";

const isProduction = isProductionEnv();

initAll(getEnv("REACT_APP_AMPLITUDE_API_KEY") ?? "", {
  serverZone: "US",
  analytics: {
    appVersion: getEnv("REACT_APP_VERSION"),
    defaultTracking: {
      pageViews: true,
      sessions: true,
      formInteractions: false,
      fileDownloads: false,
    },
    minIdLength: 1,
  },
  ...(isProduction && {
    sessionReplay: {
      sampleRate: Number(getEnv("REACT_APP_AMPLITUDE_REPLAY_SAMPLE_RATE") ?? 1),
    },
  }),
}).catch((error) => {
  console.error("[Amplitude] initAll failed:", error);
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RemoteConfigProvider>
        <UserThemeContextProvider>
          <TablesContextProvider>
            <PayerNameContextFromSingleOrderLayoutProvider>
              <ToastContainer />
              <App />
            </PayerNameContextFromSingleOrderLayoutProvider>
          </TablesContextProvider>
        </UserThemeContextProvider>
      </RemoteConfigProvider>
    </Provider>
  </React.StrictMode>,
);
